/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

//社区话题
const community = require('appComp/page/community/community/community');

const reportedpost = require('appComp/page/community/reported-post/reported-post');
const chargercomment = require('appComp/page/community/charger-comment/comment-list');

const postdetail = require('appComp/page/community/common-post/post-detail/post-detail');

const postlist = require('appComp/page/community/common-post/post-list/post-list');
const recommendlist = require('appComp/page/community/common-recommend/recommend-list/recommend-list');
const addPost = require('appComp/page/community/common-post/post-add/post-add');

const activitytopic = require('appComp/page/community/activity-topic/toplic-list/toplic-list');
const activitytopicadd = require('appComp/page/community/activity-topic/activity-topic-add/activity-topic-add');

const applyList = require('appComp/page/community/activity-topic/apply-list/apply-list');


//const detailstopic = require('appComp/page/community/details-topic/details-topic');

const generaltopiclist = require('appComp/page/community/general-topic/general-topic-list/general-topic-list');
const generaltopicadd = require('appComp/page/community/general-topic/general-topic-add/general-topic-add');

const infotopic = require('appComp/page/community/info-topic/infotopic-list/infotopic-list');
const infotopicadd = require('appComp/page/community/info-topic/infotopic-add/infotopic-add');

const detailstopic = require('appComp/page/community/details-topic/detailsTopic-list/detailsTopic-list');
const detailstopicAdd = require('appComp/page/community/details-topic/detailsTopic-add/detailsTopic-add');


module.exports = {
  component: community,
  subRoutes: {
    "/reportedpost": {
    	"component": reportedpost,
      "name":"bbs-reportedpost",
      "title": "被举报的帖子"
    },
    "/chargercomment": {
      "component": community,
      subRoutes:{
        "/":{
          "component":chargercomment,
          "name":"bbs-chargercomment",
          "title": "充电点评论"
        },
        "/detail/:id":{
          "component":postdetail,
          "name": "chager-postdetail",
          "title":"充电点帖子详情"
        }
      }
    },
    "/postlist": {
      "component": community,
        subRoutes:{
          "/":{
            "component":postlist,
             "name":"bbs-postlist",
             "title": "帖子"
          },
          "/add":{
            "component":addPost,
             "name":"bbs-addPost",
             "title": "新增帖子"
          },
          "/detail/:id":{
            "component":postdetail,
            "name": "postdetail",
            "title":"帖子详情"
          }
        }
      
    },
    "/recommend": {
      "component": community,
        subRoutes:{
          "/":{
            "component":recommendlist,
             "name":"recommend-list",
             "title": "推荐"
          }
        }
      
    },
    "/activitytopic": {
      "component": community,
      subRoutes:{
        "/":{
          "component": activitytopic,
          "name":"bbs-activitytopic",
           "title": "活动类话题"
        },
        "/add":{
          "component": activitytopicadd,
          "name":"activitytopic-add",
          "title": "新增活动类话题"
        },
        "/edit/:id":{
          "component": activitytopicadd,
          "name":"activitytopic-edit",
          "title": "活动类话题编辑"
        },
        "/apply/:id":{
          "component": applyList,
          "name":"activityApply",
          "title": "报名信息"
        }
    }
    },
    "/infotopic": {
      "component": community,
      subRoutes:{
        "/":{
          "component": infotopic,
          "name":"bbs-infotopic",
           "title": "资讯类话题"
        },
        "/add":{
          "component": infotopicadd,
          "name":"infotopicadd",
          "title":"新增资讯"
        },
        "/edit/:id":{
          "component": infotopicadd,
          "name":"infotopic-edit",
          "title": "资讯话题编辑"
        },
    }
    },

    "/generaltopic": {
      "component": community,
      subRoutes:{
        "/":{
          "component":generaltopiclist,
          "name":"bbs-generaltopic",
          "title": "互动话题"
        },
        "/add":{
          "component":generaltopicadd,
          "name": "generaltopicadd",
          "title":"新增互动话题"
        },
        "/edit/:id":{
          "component":generaltopicadd,
          "name": "generaltopic-edit",
          "title":"话题编辑"
        }
      }
    },
    "/detailstopic": {
      "component":community,
        subRoutes:{
          "/":{
          "component": detailstopic,
          "name":"bbs-detailstopic",
          "title": "资讯/活动详情"
          },
          "/add":{
            "component": detailstopicAdd,
            "name": "detailstopicadd",
            "title": "新增资讯活动详情"
          },
          "/edit/:id":{
            "component": detailstopicAdd,
            "name": "detailstopicedit",
            "title": "编辑资讯活动详情"
          }
        }
    },

  }
}



// WEBPACK FOOTER //
// ./src/appBackend/router/community.js